import React, { useContext, useState } from 'react';
import SellerUserCard from '../../../elements/SellerUserCard';
import { CardContainer, PageTitle } from '../../../elements';
import Modal from '../../../elements/Modal';
import { View, ScrollView, Text } from 'react-native';
import {
  AddSellerUserButton
} from './elements';
import NewSellerUser from './new';

import AuthContext from 'app/src/contexts/AuthContext';

const CardIndex = props => {
  const { hasPolicy } = useContext(AuthContext);
  const { sellerUsers, sellerId, setUpdatedSellerUserDetails } = props;
  const [showAddSellerUserModal, setShowAddSellerUserModal] = useState(false);

  return (
    <>
      <br />
      <Text><b>Seller Users</b></Text>
      {hasPolicy({ type: 'SellerUser', action: 'create' }) && (
        <AddSellerUserButton
          onPress={() => setShowAddSellerUserModal(true)}
        >
          <Text>
            + Add Seller User
          </Text>
        </AddSellerUserButton>
      )}
      <ScrollView>

        <CardContainer>
          {sellerUsers?.map(sellerUser => {
            return(
              <SellerUserCard
                sellerUser={sellerUser}
                setShowModal={setShowAddSellerUserModal}
                key={`sellerUser${sellerUser.id}`}
                setUpdatedSellerUserDetails={setUpdatedSellerUserDetails}
              />
            )
          })}
        </CardContainer>
        {showAddSellerUserModal &&
          <Modal
            showModal={showAddSellerUserModal}
            setShowModal={setShowAddSellerUserModal}
            modalType={'Add Seller User'}
          >
            <NewSellerUser
              setShowModal={setShowAddSellerUserModal}
              knownSellerId={sellerId}
              setUpdatedSellerUserDetails={setUpdatedSellerUserDetails}
            />
          </Modal>
        }
      </ScrollView>
    </>
  )
}

export default CardIndex;
